import MessageBusTopics from '../../../../common/MessageBusTopics';

/**
 * Advanced Search UI DOM Updater constructor
 *
 * @param {Object} messageBus  WH message bus
 * @param {Object} dom  DOM objects
 *
 * @constructor
 */
function AdvancedSearchUiDomUpdater(dom, deps) {
    this.deps = deps || {};

    this.dom = dom;
    this.scrollTop = 0;

    this.subscribeToEvents();
}

/**
 * Subscribe for search UI related events
 *
 * @returns {void}
 *
 * @private
 */
AdvancedSearchUiDomUpdater.prototype.subscribeToEvents = function () {
    window.WH.messageBus.subscribe(
        MessageBusTopics.SEARCH_OPEN, this.onOpen.bind(this)
    );

    window.WH.messageBus.subscribe(
        MessageBusTopics.SEARCH_CLOSE, this.onClose.bind(this)
    );

    window.WH.messageBus.subscribe(
        MessageBusTopics.NAVIGATION_QUERY_STRING_SEARCH, this.onQueryString.bind(this)
    );
};

// event handlers

/**
 * Open Search event handler
 *
 * @param {String} eventName  Event name
 * @param {Object} clickEvent  DOM event object
 *
 * @returns {void}
 *
 * @private
 */
AdvancedSearchUiDomUpdater.prototype.onOpen = function () {
    this.scrollTop = this.dom.body.getScrollPosition();
    this.dom.mainOffCanvas.fix();
    this.addQueryString();
};

/**
 * Close Search event handler
 *
 * @returns {void}
 *
 * @private
 */
AdvancedSearchUiDomUpdater.prototype.onClose = function () {
    // scroll the body on the position it was before opening
    this.dom.body.setScrollPosition(this.scrollTop);

    this.dom.mainOffCanvas.unfix();
    this.removeQueryString();
};


/**
 * Navigation Query String (window.location.search) received a search request
 */
AdvancedSearchUiDomUpdater.prototype.onQueryString = function () {
    window.WH.messageBus.publish(MessageBusTopics.SEARCH_OPEN);
};

// utility functions


AdvancedSearchUiDomUpdater.prototype.updateHash = function (newHash) {
    var { history, location } = window;
    if (history && history.hasOwnProperty('pushState')) {
        history.pushState('', document.title, `${location.pathname}${location.search}${newHash ? `#${newHash}`: ''}`);
    } else {
        location.hash = newHash;
    }
};

/**
 * Adds the "#search" string in the url
 */
AdvancedSearchUiDomUpdater.prototype.addQueryString = function() {
    this.updateHash('search');
    setTimeout(() => {
        window.addEventListener('popstate', this.publishClose);
    }, 100);
};

/**
 * Publishes the close event on messageBus
 * @param {PopStateEvent}  event    Event fired by a browser forward or back event
 */
AdvancedSearchUiDomUpdater.prototype.publishClose = function (event) {
    if (window.WH && window.WH.messageBus && window.WH.messageBus.publish) {
        window.WH.messageBus.publish(MessageBusTopics.SEARCH_CLOSE, event);
    }
};

/**
 * Removes the "#search" string from the url if the search closed.
 */
AdvancedSearchUiDomUpdater.prototype.removeQueryString = function() {
    if (window.location.hash === '#search') {
        this.updateHash('');
    }
    window.removeEventListener('popstate', this.publishClose);
};

export default AdvancedSearchUiDomUpdater;
